import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Demonstration from "../pages/demonstration/page";
import Product from "../pages/product/page";
import Dashboard from "../pages/dashboard/page";
import CheckoutSuccess from "../pages/checkout-success/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import SecurityPage from "../pages/security/page";
import Terms from "../pages/terms/page";
import About from "../pages/about/page";
import ContactUs from "../pages/contact/page";
import Showcase from "../pages/showcase/page";
import Changelog from "../pages/changelog/page";

// ... existing code ...

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/demonstration", element: <Demonstration /> },
  { path: "/product", element: <Product /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/checkout-success", element: <CheckoutSuccess /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <ContactUs /> },
  { path: "/showcase", element: <Showcase /> },
  { path: "/changelog", element: <Changelog /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/security", element: <SecurityPage /> },
  { path: "/terms", element: <Terms /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
